export  class LicenseAnimationTextModel {
    private readonly x: number;
    private readonly y: number;
    private readonly size: number;
    private readonly color: string;
    private readonly text: string;

    constructor(x: number, y: number, size: number, color: string, text: string) {
        this.x = x;
        this.y = y;
        this.size = size;
        this.color = color
        this.text = text;
    }
    draw(context: CanvasRenderingContext2D) {
        context.font = `${this.size}px Geologica, sans-serif`;
        context.fillStyle = this.color;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(this.text, this.x, this.y);
    }

}
